import { Button, Modal, Select, Table, message } from "antd";
import { useContext, useEffect, useState } from "react";
import { BlockResTypes, QuizResTypes, ThemeTypes } from "src/static/interface";
import {
  DeleteQuizConfig,
  GetQuizesConfig,
  GetThemesConfig,
} from "src/service/api";
import type { ColumnsType } from "antd/es/table";
import { useNavigate, useSearchParams } from "react-router-dom";
import { quizColumns } from "src/static/data/columns";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import DeleteModal from "src/components/modal/DeleteModal";
import PaginationFilter from "src/components/filter/PaginationFilter";
// import SearchFilter from "src/components/filter/SearchFilter";
import { rules } from "src/static/rules";
import { MainContext } from "src/context";

function QuizPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [visibleDelete, setVisibleDelete] = useState(false);
  const [id, setId] = useState(0);
  const [render, setRender] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataSource, setDataSource] = useState<QuizResTypes[]>([]);
  const [loading, setLoading] = useState(false);
  const [themes, setThemes] = useState<ThemeTypes[]>([]);
  const { Option } = Select;
  const { handleMakeParams } = useContext(MainContext);
  const themeId = searchParams.get("themeId") || undefined;

  const handleMakeUrl = () => {
    const params = new URLSearchParams();
    for (let key of Array.from(searchParams.keys())) {
      let value = searchParams.get(key);
      if (value) {
        params.append(key, value);
      }
    }
    const queryString = params.toString();
    return queryString ? `?${queryString}` : "";
  };

  const getFunc = () => {
    setLoading(true);
    let url = handleMakeUrl();
    GetQuizesConfig(`${url}`)
      .then((res) => {
        const arr = res.data.content;
        let size = searchParams.get("size");
        let page = searchParams.get("page");
        arr.forEach((item: BlockResTypes, index: number) => {
          item.key = page && size ? index + 1 + (+page - 1) * +size : index + 1;
        });
        setDataSource(arr);
        setTotal(res.data.totalElements);
        window.scrollTo(0, 0);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getFunc();
  }, [searchParams, themeId]);

  const getFuncThemes = () => {
    GetThemesConfig().then((res) => {
      setThemes(res.data);
    });
  };
  useEffect(() => {
    getFuncThemes();
  }, []);

  //Delete Data section
  const openDeleteModal = (Id: number) => {
    if (Id) {
      setId(Id);
      setRender(render + 1);
      setVisibleDelete(true);
    }
  };

  const closeDeleteModal = () => {
    setVisibleDelete(false);
    setId(0);
  };

  const handleDeleteFunc = () => {
    if (id)
      DeleteQuizConfig(id).then(() => {
        closeDeleteModal();
        message.success(`So'rovnoma muvaffaqiyatli o'chirildi`);
        getFunc();
      });
  };

  const columns: ColumnsType<QuizResTypes> = [
    ...quizColumns,
    {
      title: "Amallar",
      dataIndex: "id",
      key: "id",
      render: (id) => (
        <div className="layout-content-table-buttons">
          <EditOutlined
            onClick={() => {
              navigate(`actions?quizId=${id}`);
            }}
          />
          <DeleteOutlined
            onClick={() => {
              openDeleteModal(id);
            }}
          />
        </div>
      ),
    },
  ];

  const handleThemeChange = (val: string) => {
    handleMakeParams?.("themeId", val || "");
  };

  return (
    <div>
      <div className="layout-content-header">
        <p>So'rovnomalar</p>
        <div className="right">
          <Select
            allowClear
            size="middle"
            placeholder={rules.theme_s.message}
            style={{ width: 350 }}
            onChange={handleThemeChange}
            onClear={() => handleThemeChange("")}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {themes.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
          {/* <SearchFilter /> */}
          <Link to="actions">
            <Button icon={<PlusOutlined />} type="primary">
              Qo'shish
            </Button>
          </Link>
        </div>
      </div>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        loading={loading}
        bordered
      />
      <PaginationFilter total={total} />
      <div className="layout-content-total">
        Jami: <span>{total}</span>
      </div>

      {/* Delete modal */}
      <Modal
        open={visibleDelete}
        title=""
        footer=""
        width={500}
        onCancel={closeDeleteModal}
      >
        <DeleteModal
          text="So'rovnoma"
          render={render}
          closeModal={closeDeleteModal}
          deleteFunc={handleDeleteFunc}
        />
      </Modal>
    </div>
  );
}

export default QuizPage;
